import { type UUID, DbMhtmlCapture, getRangeForAllRecordsWithRecordingUuidAndRowUuid, NameOfIndexForRecordingUuidThenMhtmlCaptureUuid } from "./DatabaseTypes";
import type { EvidenceDatabase } from "./EvidenceDbStruct";

export class DbMhtmlCaptureTableReader {
	protected constructor(protected readonly db: EvidenceDatabase, public readonly recordingUuid: UUID) { }

	static #forRecordingUuid = new Map<UUID, DbMhtmlCaptureTableReader>();
	static forRecordingUuid = (db: EvidenceDatabase, recordingUuid: UUID) => DbMhtmlCaptureTableReader.#forRecordingUuid.get(recordingUuid) ?? (() => {
		const evidenceDbForRecording = new DbMhtmlCaptureTableReader(db, recordingUuid);
		DbMhtmlCaptureTableReader.#forRecordingUuid.set(recordingUuid, evidenceDbForRecording);
		return evidenceDbForRecording;
	})();

	mhtmlCapturesMapAsync = async <T>(callback: (event: DbMhtmlCapture) => Promise<T>) => {
		const db = this.db;
		const keys = await db.getAllKeysFromIndex("mhtmlCaptures", NameOfIndexForRecordingUuidThenMhtmlCaptureUuid, getRangeForAllRecordsWithRecordingUuidAndRowUuid(this.recordingUuid));
		return (await Promise.all(keys.map(async (key) => {
			const mhtmlCapture = await db.get("mhtmlCaptures", key);
			return mhtmlCapture != null ? callback(mhtmlCapture) : undefined;
		}))).filter( x => x != null)
	};
	/**
	 * Retrieve all the page capture records (each with an MHTML blob) for the recording.
	 * @returns
	 */
	mhtmlCaptures = async () => await this.db.getAllFromIndex("mhtmlCaptures", NameOfIndexForRecordingUuidThenMhtmlCaptureUuid, getRangeForAllRecordsWithRecordingUuidAndRowUuid(this.recordingUuid));


	static removeRecordingUuid = (recordingUuid: UUID) => DbMhtmlCaptureTableReader.#forRecordingUuid.delete(recordingUuid);
}
